module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"select-order-source-type":"Select Order Source Type"}}')
  delete Component.options._Ctor
}
